module.exports = __webpack_public_path__ + "static/media/microsite_app_icon.db61dae2.svg";